<template>
  <div class="identification">
    <div class="header">
      <div class="center-content">
        <div class="icon"></div>
        <div class="title">{{$t('crm_identification.qysmrz')}}</div>
      </div>
    </div>
    <div class="process-content">
      <div class="center-content">
        <process-bar :value="step" :data="processData"></process-bar>
      </div>
    </div>

    <div class="tab-content">
      <identification-protocol
        v-if="step === 0"
        @step="onStepChange"
        class="common"
      ></identification-protocol>
      <!-- 确认基本资料 -->
      <identification-base
        v-if="step === 1"
        @step="onStepChange"
        class="common"
      ></identification-base>
      <!-- 提交认证材料 -->
      <identification-submission
        v-if="step === 2"
        @step="onStepChange"
        class="common"
      ></identification-submission>
      <!-- 完成 -->
      <identification-finish v-if="step === 3"></identification-finish>
    </div>
  </div>
</template>

<script>
import identificationBase from './children/identification_base.vue';
import identificationProtocol from './children/indentification_protocol.vue';
import identificationSubmission from './children/identification_submission.vue';
import identificationFinish from './children/identification_finish.vue';
import processBar from './children/process_bar.vue';


export default {
  name: 'identification',
  components: {
    identificationBase,
    identificationSubmission,
    identificationFinish,
    processBar,
    identificationProtocol
  },
  computed: {
    processData() {
      return [
        {
          name: this.$t('crm_identification.1tong_yi_xie_yi'),
          value: 0
        },
        {
          name: this.$t('crm_identification.2que_ren_xin_xi'),
          value: 1
        },
        {
          name: this.$t('crm_identification.3ren_zheng_fang_shi'),
          value: 2
        },
        {
          name: this.$t('crm_identification.4ren_zheng_jie_guo'),
          value: 3
        }
      ];
    }
  },
  data() {
    return {
      step: 0,
      injectData: {
        submissionIndex: 0,
      },
      companyId: ''
    };
  },
  provide() {
    return {
      backToCompany: this.backToCompany,
      next: this.next,
      pre: this.pre,
      injectData: this.injectData,
      setSubmissionIndex: this.setSubmissionIndex
    };
  },
  methods: {
    next() {
      this.step++;
    },
    pre() {
      this.step--;
    },
    onStepChange(step) {
      this.step = step;
    },
    setSubmissionIndex(index) {
      this.injectData.submissionIndex = index;
    },
    backToCompany() {
      this.$router.replace('/companyInfo/msg');
    }
  },
  mounted() {
    this.companyId = this.getJump('companyId');

  }
};
</script>

<style lang="scss" scoped>
.identification {
  background: #fff;
  min-height: 100%;
  .center-content {
    width: 900px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }

  .header {
    height: 100px;
    background: linear-gradient(
      180deg,
      rgba(74, 186, 241, 1) 0%,
      rgba(61, 174, 230, 1) 100%
    );
    width: 100%;

    .center-content {
      height: 100px;
      background-image: url("~@/images/layout/identification_header_bg.png");
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .icon {
      $r: 32px;
      width: $r;
      height: $r;
      background-image: url("~@/images/layout/icon_qi.png");
      background-size: 100%;
      background-repeat: no-repeat;
      float: left;
      margin-left: 361px;
      margin-top: 34px;
    }

    .title {
      font-size: 22px;
      color: #fff;
      line-height: 32px;
      float: left;
      margin-left: 14px;
      margin-top: 34px;
      font-weight: 500;
      letter-spacing: 2px;
    }
  }

  .process-content {
    padding: 19px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .tab-content {
    width: 900px;
    margin-left: auto;
    margin-right: auto;
  }

  /deep/ .common {
    .footer {
      border-top: 1px solid #ebebeb;
      overflow: hidden;
      padding: 23px 0;
      text-align: center;

      .el-button + .el-button {
        margin-left: 16px;
      }
    }
  }
}
</style>
